export default __webpack_public_path__ + "static/media/Nunito-VariableFont_wght.ba12192b.ttf";